import {
  invoicesResponseSchema,
  type InvoicesResponse,
  type InvoiceStatus,
} from '../types/invoices';
import {
  FetchError, SubmitError 
} from '../errors';
import {
  authFetch, buildApiUrl 
} from '../lib/api-client';

export interface InvoiceFilters {status?: InvoiceStatus;}

export async function getSupplierInvoices(
  supplierId: string,
  filters?: InvoiceFilters
): Promise<InvoicesResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);

  const url = buildApiUrl(`/v1/suppliers/${supplierId}/invoices`, params);
  const response = await authFetch(url);

  if (!response.ok) {
    throw new FetchError('invoices', response.statusText);
  }

  return invoicesResponseSchema.parse(await response.json());
}

export async function submitInvoice(invoiceId: string): Promise<void> {
  const url = buildApiUrl(`/v1/invoices/${invoiceId}/submit`);
  const response = await authFetch(url, { method: 'POST' });

  if (!response.ok) {
    throw new SubmitError('invoice', response.statusText);
  }
}
